let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hFj80")).then(() => parcelRequire('fT41A'));